<template>
  <v-container class="app-container--width-max">
    <TenantsHeader @openDrawer="openDrawer" />
    <DrawerWhyChooseUs
      v-model="isDrawerOpen"
      @closeWhyChooseUsDrawer="closeDrawer"
    />
    <router-view />
  </v-container>
</template>

<script>
import TenantsHeader from "@/Layouts/TenantsLayouts/B2B/TenantsContentsLayouts/Header";
import DrawerWhyChooseUs from "@/components/QuoteResult/DrawerWhyChooseUs.vue";

export default {
  name: "TenantsContentsMainLayout",
  components: { TenantsHeader, DrawerWhyChooseUs },
  data() {
    return {
      isDrawerOpen: false,
    };
  },
  methods: {
    openDrawer() {
      this.isDrawerOpen = true;
    },
    closeDrawer() {
      this.isDrawerOpen = false;
    },
  },
};
</script>

<style scoped></style>
